import { useEffect } from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

import { Header } from "./components/header";
import { useWidgetStore } from "./stores/widget-store";
import SkeletonLoader from "./components/skeleton-loader";
import { SonnerProvider } from "./components/ui/sonner-provider";
import { CustomizeTab } from "./components/tabs/customize-tab";
import { SettingsTab } from "./components/tabs/settings-tab";

export default function App() {
  const { isLoading, fetchConfig } = useWidgetStore();
  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  return (
    <SonnerProvider>
      <TooltipProvider>
        <div className="cy:min-h-screen">
          <Header />
          {isLoading ? (
            <div className="cy:max-w-7xl cy:mx-auto cy:px-4 cy:sm:px-6 cy:lg:px-8 cy:py-8 cy:relative cy:min-h-[600px]">
              <SkeletonLoader />
            </div>
          ) : (
            <Tabs defaultValue="customize" className="cy:w-full">
              <TabsList className="cy:w-full cy:flex cy:justify-start cy:px-4 cy:h-[56px] cy:bg-white cy:border-b cy:rounded-none cy:py-0">
                <TabsTrigger
                  value="customize"
                  className="cy:-mb-1 cy:flex-none  cy:border-0 cy:border-b-3 cy:border-transparent cy:data-[state=active]:border-b-4 cy:data-[state=active]:border-primary cy:data-[state=active]:text-text-dark cy:rounded-none cy:shadow-none cy:data-[state=active]:shadow-none cy:p-0 cy:px-0 cy:mx-4 cy:text-base! cy:font-medium"
                >
                  Customise widget
                </TabsTrigger>
                <TabsTrigger
                  value="settings"
                  className="cy:-mb-1 cy:flex-none cy:border-0 cy:border-b-3  cy:border-transparent cy:data-[state=active]:border-b-4 cy:data-[state=active]:border-primary cy:data-[state=active]:text-text-dark cy:rounded-none cy:shadow-none cy:data-[state=active]:shadow-none cy:p-0 cy:px-0 cy:mx-4 cy:text-base! cy:font-medium"
                >
                  Settings
                </TabsTrigger>
              </TabsList>

              <TabsContent value="customize">
                <CustomizeTab />
              </TabsContent>

              <TabsContent value="settings">
                <SettingsTab />
              </TabsContent>
            </Tabs>
          )}
          <div className="cy:px-4 cy:py-4 cy:sm:px-6 cy:lg:px-8 cy:max-w-7xl cy:mx-auto cy:flex cy:justify-between">
            <p className="cy:text-[13px] cy:font-[300] cy:text-black">
             
              <a
                href="https://wordpress.org/support/plugin/accessibility-widget/reviews/#new-post"
                target="_blank"
                rel="noopener noreferrer"
                className="cy:text-[#1863DC] cy:no-underline hover:cy:underline"
              >
                Leave a{" "} ★★★★★
              </a>{" "}
              to keep us going. This is just the first step from CookieYes
              toward a more inclusive web. More improvements on the way!
            </p>
            <p className="cy:text-[13px] cy:font-[300] cy:text-black">Version 3.0.6</p>
          </div>
        </div>
      </TooltipProvider>
    </SonnerProvider>
  );
}
